import MonthlyProgressActionTypes from './monthly-progress.types';

/** ***************** GET PROGRESS REPORT DETAILS START *********************** */
export const getMonthlyProgressDetailsStart = (getData: any) => ({
	type: MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_START,
	payload: getData,
});

export const getMonthlyProgressDetailsSuccess = (successData: any) => ({
	type: MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_SUCCESS,
	payload: successData,
});

export const getMonthlyProgressDetailsFailure = (failureData: any) => ({
	type: MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_FAILURE,
	payload: failureData,
});

export const getMonthlyProgressDetailsResponseResetStart = () => ({
	type: MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_RESPONSE_RESET,
});

export const getMonthlyProgressDetailsResponseChanged = () => ({
	type: MonthlyProgressActionTypes.GET_MONTHLY_PROGRESS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET PROGRESS REPORT DETAILS END *********************** */
